import { createSlice } from "@reduxjs/toolkit";

export const register = createSlice({
  name: "register",
  initialState: {
    value: {
      doc: "",
      email: "",
      phone: "",
      responsible: "",
      token: "",
      password: "",
    },
  },
  reducers: {

    //TODO criar metodo set
    getDoc(state, { payload }) {
      state.value.doc = payload;
    },

    //TODO criar metodo set
    getEmail(state, { payload }) {
      state.value.email = payload;
    },

    //TODO criar metodo set
    getPhone(state, { payload }) {
      state.value.phone = payload;
    },

    //TODO criar metodo set
    getResponsiblePerson(state, { payload }) {
      state.value.responsible = payload;
    },

    //TODO criar metodo set
    getToken(state, { payload }) {
      state.value.token = payload;
    },

    //TODO criar metodo set
    getPassword(state, { payload }) {
      state.value.password = payload;
    },

    //TODO criar metodo set
    getEnterprise(state, { payload }) {
      state.value.enterprise = payload;
    },
  },
});

export const {
  getDoc,
  getEmail,
  getPhone,
  getResponsiblePerson,
  getToken,
  getPassword,
  getEnterprise,
} = register.actions;
export default register.reducer;
